






















































































import { Component, Vue, Prop, Watch } from "vue-property-decorator";
import { State, Action, Getter, Mutation } from "vuex-class";
import { API_URL } from "../global";
import { pageDataType, componentDataType, settinglinkItem } from "../types";
import {
  SET_GLOBAL_ERROR,
  SET_GLOBAL,
  SET_GLOBAL_LOADED,
  SET_SETTING_DATA,
} from "../store/mutations.names";
import {
  FETCH_GLOBAL,
  FETCH_SETTING_DATA,
  FETCH_SETTING,
} from "../store/actions.names";
import axios from "axios";
import {
  TweenMax,
  Expo,
  TimelineLite,
  Power3,
  Power4,
  Power1,
  Power2,
  TimelineMax,
} from "gsap";
import ScrollMagic from "scrollmagic";
import gsap from "scrollmagic";
@Component({
  name: "Gmap",
})
export default class Gmap extends Vue {
  @Getter("settinglink") public settinglink!: settinglinkItem[];
  @Action(FETCH_SETTING) public [FETCH_SETTING]: any;
  current = 0;
  isChange = true;
  filter = {
    address: null,
  };
  zoomLevel = 7;
  addressdata: any[] = [];
  data() {
    return {
      lat: 23.7808875,
      lng: 90.2792371,
    };
  }
  startLocation: any = {
    lat: 23.7806126,
    lng: 90.4049491,
  };
  address: string = "Headquarter";
  addressOptions = ["Headquarter", "Local"];
  @Watch("address", {
    immediate: true,
  })
  infoOptions: any = {
    pixelOffset: {
      width: 0,
      height: -35,
    },
  };
  center = {
    lat: 23.82669004587695,
    lng: 90.44378376727295,
  };

  infoPosition: null = null;
  infoContent: null = null;
  infoOpened: boolean = false;
  infoCurrentKey: null = null;
  selectedAdress: number = -1;
  selectedOption: any = "";
  options: any = [];
  selectedDrinkLabel: any = "";

  getPosition(marker: any) {
    return {
      lat: parseFloat(marker.lat),
      lng: parseFloat(marker.lng),
    };
  }
  centerMap(filter: any) {
    this.isChange = false;
if(this.isChange == false){
this.addressdata.map((item: any) => {
      if (filter == item.id) {
        (this as any).lat = item.lat;
        (this as any).lng = item.lng;

        this.zoomLevel = 18;
      }
    });
}
    
  }
  created() {
    axios
      .get(`${API_URL}/others/locations/`)
      .then((response) => {
        (this as any).addressdata = response.data;
      })
      .catch((e) => {
        (this as any).errors.push(e);
      });
  }

  mounted() {
    this[FETCH_SETTING]();
  }
}
